import { HTMLAttributes, ReactNode } from 'react';

import CloseXs from '@/assets/icons/CloseXs';

import chipButtonStyles from './ChipButton.module.css';
import styles from '@/components/UI/Button/Button.module.css';

type ChipButtonProps = HTMLAttributes<HTMLDivElement | HTMLButtonElement> & {
  onClick?: () => void;
  label?: ReactNode | string;
  disabled?: boolean;
  size?: 'small' | 'medium';
  testid?: string;
  transparentHover?: boolean;
  handleOnClose?: () => void;
};
const ChipButton = ({
  transparentHover,
  onClick,
  label,
  disabled,
  size = 'medium',
  testid,
  handleOnClose,
  ...divOrButtonProps
}: ChipButtonProps) =>
  handleOnClose ? (
    <div
      data-testid={testid}
      className={[
        styles.button,
        styles.chip,
        styles.sm,
        styles[size],
        chipButtonStyles.chipText,
        disabled ? styles.disabled : '',
        transparentHover ? styles.transparentHover : '',
      ].join(' ')}
      onClick={onClick}
      {...divOrButtonProps}
    >
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center', textWrap: 'nowrap' }}>
        {label}
        <CloseXs
          onMouseDown={handleOnClose}
          data-testid='chip-button-close-icon'
          className={chipButtonStyles.chipButtonCloseIconStyle}
        />
      </div>
    </div>
  ) : (
    <button
      type='button'
      data-testid={testid}
      className={[
        styles.button,
        styles.chip,
        styles.sm,
        styles[size],
        disabled ? styles.disabled : '',
        transparentHover ? styles.transparentHover : '',
      ].join(' ')}
      onClick={onClick}
      disabled={disabled}
      {...divOrButtonProps}
    >
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>{label}</div>
    </button>
  );
export default ChipButton;
